import { isDev } from './env';

type Level = 'debug' | 'info' | 'warn' | 'error';

function emit(level: Level, scope: string, args: unknown[]): void {
  if (level === 'debug' && !isDev) return;
  const tag = `[${scope}]`;
  console[level === 'debug' ? 'log' : level](tag, ...args);
}

export function createLogger(scope: string) {
  return {
    debug: (...args: unknown[]) => emit('debug', scope, args),
    info: (...args: unknown[]) => emit('info', scope, args),
    warn: (...args: unknown[]) => emit('warn', scope, args),
    error: (...args: unknown[]) => emit('error', scope, args),
  };
}

export const log = createLogger('app');
